import type { AllocNode } from "./buildAllocationTree";
import { AllocateAccountInline } from "./AllocateAccountInline";
import { AllocateSiteInline } from "./AllocateSiteInline";
import { VlanGeneratePanel } from "./VlanGeneratePanel";
import { VlanTable } from "./VlanTable";

export function NodeDetailPanel({
  node, canWrite, gateOk, onChanged,
}: {
  node: AllocNode | null; canWrite: boolean; gateOk: boolean; onChanged: () => void;
}) {
  if (!node) return <p style={{ color: "var(--text-dim)" }}>Select a node in the tree.</p>;

  if (node.kind === "account") {
    return node.allocated
      ? <Allocated node={node} />
      : <AllocateAccountInline accountSlug={node.refSlug!} canWrite={canWrite} gateOk={gateOk} onAllocated={onChanged} />;
  }
  if (node.kind === "site") {
    if (!node.allocated) {
      return <AllocateSiteInline siteSlug={node.refSlug!} canWrite={canWrite} gateOk={gateOk} onAllocated={onChanged} />;
    }
    return (
      <div>
        <div className="label">SITE · {node.refSlug}</div>
        <p>CIDR: <strong>{node.cidr}</strong></p>
        {node.children.length > 0
          ? <VlanTable vlans={node.children} />
          : <VlanGeneratePanel siteSlug={node.refSlug!} canWrite={canWrite} gateOk={gateOk} onGenerated={onChanged} />}
      </div>
    );
  }
  if (node.kind === "vlan") {
    return (
      <div>
        <div className="label">VLAN {node.vlanTag}</div>
        <p>CIDR: <strong>{node.cidr ?? "—"}</strong></p>
        {node.detail?.prefix_len != null && <p>prefix /{String(node.detail.prefix_len)} · offset {String(node.detail.offset_units)}</p>}
      </div>
    );
  }
  return <Allocated node={node} />;
}

function Allocated({ node }: { node: AllocNode }) {
  return (
    <div>
      <div className="label">{node.kind.toUpperCase()} · {node.label}</div>
      <p>CIDR: <strong>{node.cidr ?? "—"}</strong></p>
      {node.source && <p style={{ color: "var(--text-dim)" }}>source: {node.source}</p>}
    </div>
  );
}
